import { motion } from "framer-motion";

export const reveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
};

export default function Reveal({ children, delay = 0, className = "", as = "div" }) {
  const M = motion[as] || motion.div;
  return (
    <M
      initial={reveal.initial}
      whileInView={reveal.whileInView}
      viewport={reveal.viewport}
      transition={{ ...reveal.transition, delay }}
      className={className}
    >
      {children}
    </M>
  );
}
